export enum OrganizationStatusEnum {
    PendingVerification = 'PendingVerification',
    Active = 'Active',
    Archived = 'Archived',
    Blocked = 'Blocked',
}
